//@flow
import React from "react";
import {
  Text,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
  Platform,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import theme from "app/Theme/Theme";

type Props = {
  onPressDisabled: () => mixed,
  onPress: () => mixed,
  onPressIn: () => mixed,
  delayPressIn: number,
  text: string,
  testID: string,
  disable: false,
  disableButtonPropStyle?: {},
  buttonPropStyle?: {},
  textPropStyle?: {},
  disableTextPropStyle?: {},
  // type: string // light or plain
};

const RoundButton = ({
  testID,
  disable,
  onPressDisabled,
  onPress,
  onPressIn,
  delayPressIn,
  text,
  buttonPropStyle,
  textPropStyle,
  disableButtonPropStyle,
  disableTextPropStyle,
}: Props) => {
  let { buttonStyle, textStyle } = styles;
  buttonStyle = buttonPropStyle
    ? { ...buttonStyle, ...buttonPropStyle }
    : buttonStyle;
  textStyle = textPropStyle ? { ...textStyle, ...textPropStyle } : textStyle;

  const result = !disable ? (
    <TouchableOpacity
      onPress={onPress}
      style={buttonStyle}
      testID={testID}
      onPressIn={onPressIn}
      delayPressIn={delayPressIn}
    >
      <Text style={textStyle}>{text}</Text>
    </TouchableOpacity>
  ) : (
    <TouchableWithoutFeedback onPress={onPressDisabled} testID={testID}>
      <View
        style={{
          ...buttonStyle,
          backgroundColor: theme.colors["neutral.400"],
          ...disableButtonPropStyle,
        }}
      >
        <Text style={{ ...textStyle, ...disableTextPropStyle }}>{text}</Text>
      </View>
    </TouchableWithoutFeedback>
  );
  return result;
};

const styles = {
  textStyle: {
    textAlign: "center",
    alignSelf: "center",
    color: "#1486f3",
    // fontSize: width < 340 ? 18 : 22,
    fontSize: wp("4%"),
    // width: "100%",
    fontWeight: "normal",
    padding: 10,
    paddingTop: 5,
    paddingBottom: 5,
  },
  buttonStyle: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#eaf4ff",
    borderRadius: 40,
    borderWidth: Platform.OS === "ios" ? 1 : 0,
    borderColor: "rgba(20,134,243,0.09)",
  },
};

export { RoundButton };
